/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        $('#load').on('click', function() {
            var $this = $(this);
            var loadingText = '<i class="fa fa-circle-o-notch fa-spin"></i> buscando...';
            if ($(this).html() !== loadingText) {
              $this.data('original-text', $(this).html());
              $this.html(loadingText);
            }
            setTimeout(function() {
              $this.html($this.data('original-text'));
            }, 6000);
          });


        ////MENU MOBILE  
          //attach overlay to the page
            //build overlay
            $menuOverlay = $('<div class="menu-overlay"></div>');

            //apend menu to overlay
            $("header .nav-primary").clone().prependTo($menuOverlay);
            
            //add close button to overlay
            $('#close-menu').appendTo($menuOverlay);

            //append overlay to body
            $("body").append($menuOverlay);

          //show mobile navigation when click the button
            $("#menu").on('click',function(event){

              event.preventDefault();
              $(".menu-overlay .nav-primary").show();
              $menuOverlay.fadeIn('slow');
              $('#menu').fadeOut('slow'); 

            });

          //close navigation
          $("#close-menu").on('click',function(event){

            $('#menu').fadeIn('slow'); 
            event.preventDefault();
            $menuOverlay.fadeOut('medium'); 

          });

        ////END MENU MOBILE 


        // CAROUSEL

          $('.slick-quartos').slick({
            dots: false,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            cssEase: 'ease',
            autoplay: true,
            autoplaySpeed: 2000
          });

        $(function () {
          $('[data-toggle="tooltip"]').tooltip();
        });

        // REGULAMENTO ADD ATRIBUTE BEHAVIOR
        $(".mapa-pontos").on('click',function(event){

          event.preventDefault();
          $('#modalpontos').modal('toggle');

        });

        // NAO DEIXAR IR PRO QUARTO
        $(".hb_room_type a").on('click',function(event){

          event.preventDefault();

        });

        $(".hb-room-name a").on('click',function(event){

          event.preventDefault();

        });

        $(".sua-reserva #booking-items a").on('click',function(event){

          event.preventDefault();

        });

       

         // FIXED SEARCH

           $(window).scroll(function () { 

            if($(window).width() > 770 ) {
                if($(window).scrollTop() > 550 ) {
                    $(".fixed-block").css({"position" : "fixed", "top" : "0", "right" : "0"});
                    
                } else {
                    $(".fixed-block").css("position", "relative");
                }        
            } 
           });

             
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
